import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { FaSearch, FaFilePdf, FaDownload, FaExternalLinkAlt } from "react-icons/fa";
import { testUrl } from "../home/BaseData";
import classes from "./DarsJadvali.module.css";
import PdfViewer from "./PdfViewer";

const PAGE_TITLE = "1-KURS KUNDUZGI TA’LIM TALABALARI UCHUN METODIK HAFTALIK DARS JADVALI";
const PAGE_DESCRIPTION =
  "Mazkur metodik haftalik dars jadvali Renesans Ta’lim Universitetining 1-kurs kunduzgi ta’lim shaklida tahsil olayotgan talabalarining o‘quv jarayonini tizimli tashkil etish, ta’lim mashg‘ulotlarini samarali rejalashtirish hamda talabalarning akademik faoliyatini muvofiqlashtirish maqsadida ishlab chiqilgan.";

const DarsJadvali = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState([]);
  const [query, setQuery] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${testUrl}/api/timetable-pdfs/`);
        const list = Array.isArray(response.data) ? response.data : [];
        setFiles(list);
        setSelectedId((prev) => (prev ?? (list.length > 0 ? list[0].id : null)));
      } catch (err) {
        setError(t("errorLoadingData") || "Ma'lumotlarni yuklashda xatolik");
      } finally {
        setLoading(false);
      }
    };
    fetchFiles();
  }, [t]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return files;
    return files.filter((f) => (f.name || "").toLowerCase().includes(q));
  }, [files, query]);

  // Tanlangan fayl qidiruv natijasidan chiqib ketsa, ro'yxatdagi birinchisiga o'tiladi.
  useEffect(() => {
    if (filtered.length === 0) return;
    if (!filtered.some((f) => f.id === selectedId)) {
      setSelectedId(filtered[0].id);
    }
  }, [filtered, selectedId]);

  const selected = files.find((f) => f.id === selectedId) || null;
  const noResultsText = t("timetableNoResults") || "Qidiruvga mos jadval topilmadi";

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h1 className={classes.title}>{PAGE_TITLE}</h1>
        <p className={classes.description}>{PAGE_DESCRIPTION}</p>
      </div>

      <div className={classes.searchBar}>
        <FaSearch className={classes.searchIcon} aria-hidden="true" />
        <input
          type="search"
          className={classes.searchInput}
          placeholder={t("timetableSearchPlaceholder") || "Dars jadvalini qidirish..."}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label={t("timetableSearchPlaceholder") || "Dars jadvalini qidirish"}
        />
      </div>

      {loading ? (
        <div className={classes.state}>{t("loading") || "Yuklanmoqda..."}</div>
      ) : error ? (
        <div className={`${classes.state} ${classes.error}`}>{error}</div>
      ) : files.length === 0 ? (
        <div className={classes.state}>
          {t("noFilesAvailable") || "Hozircha hech qanday fayl mavjud emas"}
        </div>
      ) : (
        <div className={classes.layout}>
          <aside className={classes.list} aria-label="PDF">
            {filtered.length === 0 ? (
              <div className={classes.state}>{noResultsText}</div>
            ) : (
              filtered.map((item) => (
                <button
                  type="button"
                  key={item.id}
                  className={`${classes.listItem} ${item.id === selectedId ? classes.active : ""}`}
                  onClick={() => setSelectedId(item.id)}
                >
                  <FaFilePdf className={classes.pdfIcon} aria-hidden="true" />
                  <span className={classes.listName}>{item.name}</span>
                </button>
              ))
            )}
          </aside>

          <section className={classes.viewer}>
            {selected ? (
              <>
                <div className={classes.viewerHead}>
                  <h2 className={classes.viewerTitle}>{selected.name}</h2>
                  <div className={classes.viewerActions}>
                    <a
                      href={selected.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.openBtn}
                    >
                      <FaExternalLinkAlt aria-hidden="true" />{" "}
                      {t("openInNewTab") || "Yangi oynada ochish"}
                    </a>
                    <a href={selected.file} download className={classes.downloadBtn}>
                      <FaDownload aria-hidden="true" /> {t("download") || "Yuklab olish"}
                    </a>
                  </div>
                </div>
                <PdfViewer
                  key={selected.id}
                  url={selected.file}
                  loadingText={t("loading") || "Yuklanmoqda..."}
                  errorText={t("errorLoadingData") || "Faylni ochib bo'lmadi"}
                />
              </>
            ) : (
              <div className={classes.state}>{noResultsText}</div>
            )}
          </section>
        </div>
      )}
    </div>
  );
};

export default DarsJadvali;
